if (!customElements.get('free-delivery-banner')) {
  customElements.define(
    'free-delivery-banner',
    class FreeDeliveryBanner extends HTMLElement {
      constructor() {
        super();
        this.url = this.dataset.url;
        this.sectionId = this.dataset.sectionId;
        this.container = this.closest('[data-free-delivery-banner-container]');
        this.messageContainer = this.querySelector('[data-message]');
        this.stateMessages = {
          under: this.dataset.underMessage,
          product: this.dataset.productMessage,
          over: this.dataset.overMessage,
        };
      }
      connectedCallback() {
        this.getData();
      }
      getData() {
        if (this.rawData == null) {
          return this.classList.add('hidden');
        }
        try {
          this.data = JSON.parse(this.rawData.innerText);
          this.renderMessage();
        } catch (e) {
          console.error(e);
          return this.classList.add('hidden');
        }
      }
      refreshData() {
        this.data = null;
        this.loading = true;
        fetch(`${this.url}?section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            let source = html.querySelector('free-delivery-banner');
            if (source != null) {
              this.innerHTML = source.innerHTML;
              this.dataset.cartTotal = source.dataset.cartTotal;
              this.dataset.price = source.dataset.price;
              this.getData();
            } else {
              this.classList.add('hidden');
            }
            this.loading = false;
          });
      }
      set loading(loadingState) {
        this._loading = loadingState;
        this.classList.toggle('loading', loadingState);
        if (this.loadingSpinner) {
          this.loadingSpinner.classList.toggle('hidden', !loadingState);
        }
      }
      get messageElement() {
        return this.querySelector('[data-message]');
      }
      get loadingSpinner() {
        return this.querySelector('.loading__spinner');
      }
      get loading() {
        return this._loading;
      }
      get rawData() {
        return document.querySelector('[data-free-delivery-data]');
      }
      get price() {
        return this.dataset.price != null ? parseInt(this.dataset.price) : null;
      }
      get cartTotal() {
        return parseInt(this.dataset.cartTotal);
      }
      formatMoney(number) {
        let currency = Shopify.currency.active;
        let locale = Shopify.locale;
        let country = Shopify.country;
        let formatted = '';
        try {
          formatted = new Intl.NumberFormat(`${locale}-${country}`, {
            style: 'currency',
            currency: currency,
            trailingZeroDisplay: 'stripIfInteger',
          }).format(number);
        } catch (e) {
          console.error(e);
          formatted = `£${number.toFixed(2)}`;
        }
        return formatted;
      }
      refreshCartTotal(cartTotal) {
        this.dataset.cartTotal = cartTotal;
        this.renderMessage();
      }
      async renderMessage() {
        if (this.container.dataset.country == null) {
          let response = await fetch(`/browsing_context_suggestions.json`);
          let data = await response.json();
          let country = data.detected_values.country.handle;
          this.container.dataset.country = country;
        }
        let country = this.container.dataset.country;
        let applicableGroup = this.data.freeDeliveryGroups.find((group) => group.countries.includes(country));
        if (applicableGroup != undefined) {
          let cutoff = applicableGroup.cutoff * 100;
          let state = 'under';
          let difference = cutoff - this.cartTotal;
          if (this.price != null) {
            if (this.cartTotal + this.price >= cutoff) {
              state = 'product';
            }
          }
          if (this.cartTotal >= cutoff) {
            state = 'over';
          }
          let message = this.stateMessages[state];
          if (message == '' || message == undefined) {
            return this.classList.add('hidden');
          }
          this.messageElement.innerHTML = message.replace(
            '[[amount]]',
            `<span class='font-weight-semi-bold'>${this.formatMoney(difference / 100)}</span>`
          );
          this.classList.remove('hidden');
        }
      }
    }
  );
}
